import React from 'react';
import SelectRecipientModal from '../../../../dashboard/components/Modals/SelectRecipientModal';
import ManageDistList from '../../../../dashboard/components/Modals/ManageDistList';
import { useDashboardContext } from '../../../../dashboard/context';
import GroupDetailsUpdations from '../../../../dashboard/components/Modals/GroupDetailsUpations';
import PropTypes from 'prop-types';
import { useAssignmentContext } from '../../../context';
import { useEffect } from 'react';
import CustomToast from '../../../../../components/Toast';

const ShareMenuModal = ({ assignmentId, fromMoreAction,isModalOpen }) => {
  const { allAssignmentShareUsers, setAllAssignmentShareUsers, selectRecipient, setSelectRecipient } = useDashboardContext();
  const [isLoader, setIsLoader] = React.useState(false);
  const { assignedData, setAssignedData, setAssignmentId, setAssignedDataStatus, selectedCount, assignmentIdSend} = useAssignmentContext();
  const isError = selectedCount > 20 && !fromMoreAction;

  useEffect(() => {
    setIsLoader(false);
  }, [allAssignmentShareUsers]);

  useEffect(() => {
    if (isError && selectRecipient) {
      CustomToast('You can only select up to 20 assignments', 'warning');
      setSelectRecipient(false);
    }
  }, [isError]);

  return (
    <>
      {
        !isError &&
          <>
            <SelectRecipientModal
              assignmentId={assignmentId.length > 0 ? assignmentId : assignmentIdSend}
              assignments={true}
              title={'Send Copy of Selected Assignments'}
              saveButton={'Send Copy'}
              addRemoveListHeader={'Send Copy to'}
              addByLabel={'Add by Groups'}
              manageButton={'Select/Manage Groups'}
              dataArray={allAssignmentShareUsers}
              setDataArray={setAllAssignmentShareUsers}
              resetGridData={setAssignedDataStatus}
              resetSelectedAssignment={assignedData.length > 0 ? setAssignedData : setAssignmentId}
              loader={isLoader}
              setLoader={setIsLoader}
              isModalOpen={isModalOpen}
            />
            <GroupDetailsUpdations assignments={true} />
            <ManageDistList
              assignments={true}
              title={'Manage Groups'}
              label={'Enter the name for the group'}
              createButton={'Create Group'}
              firstColumnTitle={'Group Name'}
            />
          </>
        
      }
    </>
  );
};

ShareMenuModal.propTypes = {
  assignmentId: PropTypes.array.isRequired,
  fromMoreAction: PropTypes.bool,
  isModalOpen: PropTypes.func
};

export default ShareMenuModal;
